module.exports = __webpack_public_path__ + "img/customers_say_03.baabbdae.jpg";